<template>
  <div class="container">
    <!-- 内容循环展示 -->
    <div class="section" v-for="(content, index) in contents" :key="index">
      <template v-if="content.type === 'image'">
        <div class="image-container">
          <el-image class="background-image" :src="content.src" fit="contain"></el-image>
        </div>
      </template>
      <template v-else-if="content.type === 'video'">
        <div class="video-container">
          <video ref="video" class="video" :autoplay="index === 0" controls>
            <source :src="content.src" type="video/mp4" />
            您的浏览器不支持 HTML5 视频。
          </video>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contents: [
        { type: 'image', src: require('@/assets/images/st-1.jpg') },
        { type: 'video', src: require('@/assets/video/st-2.mp4') },
        { type: 'image', src: require('@/assets/images/st-3.jpg') },
        { type: 'image', src: require('@/assets/images/st-4.png') },
        { type: 'image', src: require('@/assets/images/st-5.png') },
        { type: 'image', src: require('@/assets/images/st-6.png') },
        { type: 'image', src: require('@/assets/images/st-7.png') },
        { type: 'image', src: require('@/assets/images/st-8.png') },
        { type: 'image', src: require('@/assets/images/st-9.png') },
        { type: 'image', src: require('@/assets/images/st-10.jpg') },
      ],
    }
  },
  mounted() {
    this.$nextTick(() => {
      const videos = this.$refs.video
      if (Array.isArray(videos)) {
        videos.forEach(video => {
          video.play()
        })
      } else if (videos) {
        videos.play()
      }
    })
  },
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  position: relative;
  width: 100%;
  overflow: hidden;
  text-align: center;
}

.section {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.background-image {
  width: 100%;
  height: auto;
  object-fit: contain; /* 确保图片按比例缩放且不留白 */
}

.video-container {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.video {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 确保视频按比例缩放并填充整个容器 */
}

@media screen and (max-width: 768px) {
  .video {
    width: 100%;
    height: auto;
  }
}
</style>
